module.exports = __webpack_public_path__ + "static/media/laptop.e74203d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/laptop.jpg
// module id = 126
// module chunks = 0